import React, { Component, createRef } from "react";
import { Editor } from './WyswigEditorCK'
import { connect } from 'react-redux';
import { renderToString } from 'react-dom/server'

import { Button, Form, ButtonToolbar, Modal } from 'react-bootstrap';
import alertify from 'alertifyjs';
import { saveBlog, fetchBlog, fetchCategories, fetchLanguages, translateText, updateBlog } from '../actions/api'
// import { convertToRaw, convertFromRaw, EditorState } from 'draft-js';
import 'datatables.net-bs4/css/dataTables.bootstrap4.css';
import { SERVER_URL } from '../Middlewares/app';
import axios from "axios";
import Croppie from 'croppie';
import "croppie/croppie.css";

// import {
//   faCopy
// } from '@fortawesome/free-solid-svg-icons';

// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// import styles from './Dropzone.module.css';

import "../assets/libs/dropzone/dist/dropzone.css";
const Dropzone = require('dropzone');

class BlogForm extends Component {
  constructor(props) {
    super(props);
    const { blogPayload, isEdit, isNew } = props.location.state || {};
    let { blog_id } = blogPayload || {};
    // if (content)
    //   editorState = EditorState.createWithContent(convertFromRaw(markdownToDraft(content)));
    // console.log(blogBodyRaw);
    // if (blogBodyRaw)
    //   editorState = EditorState.createWithContent(convertFromRaw(JSON.parse(blogBodyRaw)));

    this.state = {
      // categories: null,
      blog_id,
      // content,
      // title,
      // featuredMediaPath,
      // featuredMediaType,
      // featuredImageUrl,
      // category_id,
      // editorState,
      isEdit,
      isNew,
      showModal: false,
      // extraMedia,
      // blogBodyRaw
    }
    this.dropref = createRef();
    this.cropRef = createRef();
    this.myDropzone = null;
    this.saveBlog = props.saveBlog;
    this.updateBlog = props.updateBlog;
    if (isNew) {
      this.resetForm();
    }
  }

  saveBlogBody = () => {
    const { title, featuredMediaUrl, featuredMediaType, featuredImageUrl, category_id, editorState, language_id, isBreaking, summery } = this.state;
    const blogBody = editorState //? editorState//.getCurrentContent().getPlainText('') : null;
    // const blogBodyRaw = editorState //? JSON.stringify(convertToRaw(editorState.getCurrentContent())) : null;
    // console.log(blogBody);
    if (!title || title === "")
      alertify.error("Please fill title.");
    else if (!blogBody || blogBody === "" || blogBody.length < 5)
      alertify.error("Please fill description.");
    else if (!category_id || category_id === 0)
      alertify.error("Please select a category.");
    else {
      // const blogBody = draftToMarkdown(convertToRaw(editorState.getCurrentContent()));
      const { files, fileUploadPromise } = this.dropzoneUploadTask();

      const payload = {
        description: blogBody,
        title: title,
        featuredMediaUrl: featuredMediaUrl,
        featuredMediaType: featuredMediaType,
        // featuredMediaFileName: featuredMediaFile && featuredMediaFile.name,
        featuredImageUrl,
        category_id: category_id,
        extra_media: files,
        // blogBodyRaw,
        language_id,
        isBreaking,
        summery
      };
      // console.log(payload);
      this.saveBlog(payload);
      var saveBlogPromise = new Promise((resolve, reject) => {
        var intv = setInterval(() => {
          console.log("in interval");
          if (this.props.blogSaved) {
            resolve();
            clearInterval(intv);
          }
        }, 1000);
      });
      Promise.all([saveBlogPromise, fileUploadPromise]).then(res => {
        console.log("Done");
        this.resetForm();
        this.props.history.push('/main/blogs/view');
      })
    }
  }

  dropzoneUploadTask() {
    var fileUploadPromise;
    var files = [];

    if (this.myDropzone && this.myDropzone.files.length > 0 && this.myDropzone.files.length !== this.myDropzone.getFilesWithStatus(Dropzone.SUCCESS).length) {
      this.uploadAll();
      fileUploadPromise = new Promise((resolve, reject) => {
        this.myDropzone.on('queuecomplete', () => {
          console.log('files uploaded');
          resolve();
        });
      });
    }
    else {
      fileUploadPromise = Promise.resolve();
    }
    this.myDropzone.files.forEach(element => {
      files.push({
        media_name: element.name,
        media_url: element.accessUrl,
        media_type: element.type
      });
    });

    return { files, fileUploadPromise };
  }

  updateBlogBody = () => {
    const { title, category_id, editorState, blog_id, featuredImageUrl, featuredMediaUrl, featuredMediaType, language_id, task, isBreaking, summery } = this.state;
    const blogBody = editorState//.getCurrentContent().getPlainText('');
    const blogBodyRaw = editorState// ? JSON.stringify(convertToRaw(editorState.getCurrentContent())) : null;
    const { files, fileUploadPromise } = this.dropzoneUploadTask();

    const payload = {
      blog_id,
      description: blogBody,
      title,
      category_id,
      extra_media: files,
      blogBodyRaw,
      featuredImageUrl,
      featuredMediaUrl,
      featuredMediaType,
      language_id,
      task,
      isBreaking,
      summery
    }
    this.updateBlog(payload);

    var updateBlogPromise = new Promise((resolve, reject) => {
      var intv = setInterval(() => {
        console.log("in interval");
        if (this.props.blogUpdated) {
          resolve();
          clearInterval(intv);
        }
      }, 1000);
    });
    Promise.all([updateBlogPromise, fileUploadPromise]).then(res => {
      console.log("Done");
      this.resetForm();
      alertify.success("Blog updated successfully.");
      this.props.history.push('/main/blogs/view');
    })
  }

  resetForm(callback) {
    const formInitialState = {
      content: "",
      title: "",
      blog_id: null,
      language_id: 0,
      category_id: 0,
      featuredMediaPath: null,
      featuredMediaFile: null,
      featuredMediaString: null,
      editorState: "",
      readUpcomingBlog: false
    }
    this.myDropzone && this.myDropzone.removeAllFiles();
    this.setState({ ...formInitialState })
    return true;
  }

  setTitle(e) {
    this.setState({ title: e.target.value })
  }

  setCategory(e) {
    this.setState({ category_id: e.target.value })
  }

  setLanguage(e) {
    this.handleLanguageChange(parseInt(e.target.value))
  }

  handlePublishChange() {
    const val = document.getElementById('publish-switch').checked;
    if (!val)
      this.setState({ task: 'UNPUBLISH' })
  }

  handleBreakingChange() {
    const val = document.getElementById('breaking-switch').checked;
    this.setState({ isBreaking: val });
  }

  setSummery(e) {
    this.setState({ summery: e.target.value })
  }

  setEditorState(editorState) {
    this.setState({ editorState })
  }

  handleFileUpload(file, callback) {
    file.dropzoneCompleteCallback = (e) => {
      callback('success', { url: e.accessUrl });
    }
    file.dropzoneConfirmCallback = e => {
      // this.myDropzone.enqueueFile(file);
    }
    file.uploadImmedietly = true;
    this.myDropzone.addFile(file);
  }

  componentWillUnmount() {
    this.resetForm();
  }

  componentDidMount() {
    if (this.state.isEdit && !this.state.fetched) {
      this.props.fetchBlog({ blog_id: this.state.blog_id });
      this.setState({ readUpcomingBlog: true })
    }
    if (this.state.categories === undefined || this.state.categories === null)
      this.props.fetchCategories();
    if (this.state.languages === undefined || this.state.languages === null)
      this.props.fetchLanguages();

    var pt = renderToString(
      <div id="template" className="file-row dz-preview dz-file-preview">
        {/* <!-- This is used as the file preview template --> */}
        <hr />
        <div>
          <span className="preview"><img alt="" data-dz-thumbnail /></span>
        </div>
        <div>
          <p className="name" data-dz-name></p>
          <strong className="error text-danger" data-dz-errormessage></strong>
        </div>
        <div>
          <p className="size" data-dz-size></p>
          <div className="progress progress-striped active" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="0">
            <div className="progress-bar progress-bar-success" style={{ width: '0%' }} data-dz-uploadprogress>
              <span className="progress-text"></span>
            </div>
          </div>
        </div>
        <div>
          {/* <button className="btn btn-primary start">
            <i className="glyphicon glyphicon-upload"></i>
            <span>Start</span>
          </button> */}
          {/* <button data-dz-remove className="btn btn-warning cancel">
            <i className="glyphicon glyphicon-ban-circle"></i>
            <span>Cancel</span>
          </button> */}
          <button data-dz-remove className="btn btn-danger m-1 delete">
            <i className="glyphicon glyphicon-trash"></i>
            <span>Delete</span>
          </button>

          {/* <Button variant="secondary" className="copy">
            <i className="glyphicon glyphicon-copy"></i>
            <span>Copy URL</span>
          </Button> */}
          <Button variant="info" className="m-1 view">View</Button>
          <input className="btn featured-media-select" type="radio" name="FeaturedImage" value="option1" />
          <label className="form-check-label" htmlFor="FeaturedImage">
            Use as featured media
          </label>
          <input className="btn thumbnail-select" type="radio" name="Thumbnail" value="option2" />
          <label className="form-check-label" htmlFor="Thumbnail">
            Use as thumbnail
          </label>
        </div>
        <hr />
      </div>)
    if (!this.myDropzone) {
      Dropzone.autoDiscover = false;
      const myDropzone = new Dropzone(this.dropref.current, {
        url: (files) => {
          return files[0].dynamicUploadUrl
        },
        accept: async (file, done) => {
          if (!file.isExisting) {
            const res = await axios({
              url: SERVER_URL + '/getPresignedUploadUrl',
              params: {
                contentType: file.type,
                fileName: file.name,
                v2: true,
                path: 'public/static'
              },
              method: 'GET',
              headers: { Authorization: this.props.user.token }
            })

            file.dynamicUploadUrl = res.data.result.uploadUrl;
            file.accessUrl = res.data.result.accessUrl;
            if (file.dropzoneConfirmCallback) {
              file.dropzoneConfirmCallback(file.accessUrl);
              file.dropzoneConfirmCallback = undefined;
            }

            // TODO: need to optimize
            if (file.type.match('video.*')) {
              // const reader = new FileReader();
              // reader.onload = () => {
              //   file.dataURL = reader.result;
              done();
              // }
              // reader.readAsDataURL(file);
              // file.dataURL = window.URL.createObjectURL(file);
            }
            else
              done();
          }
          else {
            // file.status = Dropzone.SUCCESS;
            done();
            this.myDropzone.files.push(file);
            // myDropzone.emit('complete', file);
          }
        },
        method: "PUT",
        previewTemplate: pt,
        autoQueue: false,
        previewsContainer: "#previews",
        clickable: '.fileinput-button',
        // successmultiple: (res) => {
        //   console.log(res);
        // },
        // success: (res) => {
        //   console.log(res);
        // },
        complete: (file) => {
          file.dropzoneCompleteCallback && file.dropzoneCompleteCallback(file)
        },
        sending: (file, xhr) => {
          let _send = xhr.send
          xhr.send = () => _send.call(xhr, file)
        },
        uploadprogress: (file, progress, bytesSent) => {
          if (file.previewElement) {
            var progressElement = file.previewElement.querySelector("[data-dz-uploadprogress]");
            progressElement.style.width = progress + "%";
            progressElement.querySelector(".progress-text").textContent = parseInt(progress) + " %";
          }
        },
        maxFilesize: 1536,
        parallelUploads: 2,
        timeout: 1800000
        // sendingmultiple:
      });
      myDropzone.on('addedfile', (file) => {
        // console.log(file);
        // file.previewElement.querySelector(".start").addEventListener('click', function (e) { e.preventDefault(); myDropzone.enqueueFile(file); });
        // file.previewElement.querySelector('.copy').addEventListener('click', function (e) {
        //   e.preventDefault();
        // });
        if (file.uploadImmedietly) {
          // file.
          console.log(file.status);
          setTimeout(() => {
            myDropzone.enqueueFile(file);
          }, 5000)
        }
        file.previewElement.querySelector('.delete').addEventListener('click', function (e) {
          e.preventDefault();
        });
        file.previewElement.querySelector('.view').addEventListener('click', (e) => {
          e.preventDefault();
          this.handleShow(file)
        });
        file.previewElement.querySelector('.featured-media-select').addEventListener('click', (e) => {
          // e.preventDefault();
          this.handleFeaturedMediaSelect(file);
        });
        file.previewElement.querySelector('.thumbnail-select').addEventListener('click', (e) => {
          // e.preventDefault();
          this.handleThumbnailSelect(file);
        });

        if (file.isExisting) {
          file.previewElement.querySelector('[data-dz-remove]').disabled = true;
        }
      });
      this.myDropzone = myDropzone;
      console.log(myDropzone);


    }
    //   Dropzone.prototype.uploadFiles = files => files.map(file => {
    //     console.log(file);
    //     let progress = i => myDropzone.emit('uploadprogress', file, i.loaded * 100 / i.total, i.loaded);
    //     axios({
    //       url: file.dynamicUploadUrl,
    //       method: "PUT",
    //       data: file,
    //       onUploadProgress: progress
    //     }).then(result => {
    //       console.log(result);
    //       console.log(Dropzone.SUCCESS);
    //       myDropzone.emit(Dropzone.SUCCESS, file);
    //     }).catch(err => {
    //       myDropzone.emit(Dropzone.ERROR, file, err);
    //     })
    //   })
  }

  uploadAll() {
    // console.log(this.myDropzone)
    this.myDropzone.enqueueFiles(this.myDropzone.getFilesWithStatus(Dropzone.ADDED));
  }

  async populateForm(payload) {
    if (payload.length === 0) {
      alertify.error('Blog not found')
      return
    }
    if (!this.state.populated) {
      const default_blog = payload[0];
      const { id, title, description, language_id, category_id, is_publish, extraMedia, featured_image, featured_media, featured_media_type, summery, is_breaking } = default_blog;
      this.setState({
        blog_id: id,
        title,
        editorState: description,
        summery,
        language_id,
        category_id,
        blog: payload,
        readUpcomingBlog: false,
        is_publish,
        isBreaking: is_breaking,
        extraMedia,
        populated: true,
        featuredImageUrl: featured_image,
        featuredMediaPath: featured_media,
        featuredMediaType: featured_media_type
      })
      if (extraMedia) {
        extraMedia.forEach(element => {
          axios({
            url: element.media_url,
            method: "HEAD"
          }).then(res => {
            var mockFile = {
              name: element.media_name,
              dataURL: element.media_url,
              accessUrl: element.media_url,
              type: element.media_type,
              isExisting: true,
              size: parseInt(res.headers['content-length']),
              media_id: element.media_id
            };
            // myDropzone.addFile(mockFile);
            this.myDropzone.displayExistingFile(mockFile, mockFile.accessUrl, e => {
            }, 'Anonymous', true);
          })
        })
      }
    }
  }

  componentDidUpdate(nextProps, nextState) {
    if (nextProps.categories && nextProps.categories.state && nextProps.categories.data !== this.state.categories) {
      this.setState({ categories: nextProps.categories.data });
      // return false
    }
    else if (nextProps.languages && nextProps.languages.state && nextProps.languages.data !== this.state.languages) {
      this.setState({ languages: nextProps.languages.data });
      // return false
    }
    else if (nextProps.blog && nextProps.blog.state && nextProps.blog.data !== this.state.blog && !this.state.fetched) {
      if (this.state.readUpcomingBlog) {
        const payload = nextProps.blog.data;
        this.setState((prevState, props) => {
          if (!prevState.fetched) {
            return { fetched: true }
          }
        })
        this.populateForm(payload)
      }
      // return false
    }
  }

  handleClose = () => {
    if (this.state.file && this.state.file.type.match("video.*") && !this.state.file.isExisting) {
      window.URL.revokeObjectURL(this.state.file.objectURL);
    }
    this.setState({ showModal: false, file: null })
  }

  handleShow = async (e) => {
    if (e.isExisting) {
      e.objectURL = e.dataURL;
    }
    else if (e.type.match("video.*")) {
      var t = await window.URL.createObjectURL(e);
      e.objectURL = t;
    }
    this.setState({ showModal: true, file: e })
  }

  handleCropClose() {
    this.setState({ showCropModal: false }, () => {
      this.Crop.destroy();
    })
  }

  handleCropImage() {
    if (this.Crop !== null) {
      this.Crop.result({
        type: 'base64',
        size: {
          width: 400
        },
        format: 'jpeg',
        quality: 0.8
      }).then((blob) => {
        this.setFeaturedImage(blob, null, 'jpeg');
        this.handleCropClose();
      }
      )
    }
  }

  handleCropShow(e) {
    this.setState({ showCropModal: true }, () => {
      const el = document.getElementById('CropModal');
      // const mini = Math.min(el.offsetHeight, el.offsetWidth);
      var boundaryWidth = el.offsetWidth - el.offsetWidth * 10 / 100;
      var boundaryHight = boundaryWidth / 1.7;
      var viewportWidth = boundaryWidth - boundaryWidth * .25;
      var viewportHight = boundaryHight - boundaryHight * .25;
      this.Crop = new Croppie(this.cropRef.current, {
        // enableExif: true,
        viewport: {
          height: viewportHight,
          width: viewportWidth,
        },
        boundary: {
          height: boundaryHight,
          width: boundaryWidth,
        },
        enforceBoundary: false,
        enableOrientation: true,
      });
      this.Crop.bind({ url: e });
    })

  }

  async handleCaptureClick() {
    // const file = this.state.file;
    let VIDEO = document.getElementById('videoPreview');
    // document.createElement('video');
    // VIDEO.src = file.dataURL;
    // VIDEO.type = file.type;
    // VIDEO.crossOrigin = "anonymous";
    this.capture(VIDEO, (image) => {
      this.setState({ featuredImage: image, featuredImageUrl: null })

      let file = dataURLtoFile(image, 'thumbnail.png');
      file.dropzoneConfirmCallback = (accessUrl) => {
        this.setState({ featuredImageUrl: accessUrl })
      }
      this.myDropzone.addFile(file);
    })
  }

  setFeaturedImage(image, imageUrl, type = "png") {
    if (image && !imageUrl) {
      if (typeof (image) === "string") {
        this.setState({ featuredImage: image })
        let file = dataURLtoFile(image, `thumbnailCrop.${type}`);
        file.dropzoneConfirmCallback = (accessUrl) => {
          this.setState({ featuredImageUrl: accessUrl })
        }
        this.myDropzone.addFile(file);
      }
    }
    else if (image && imageUrl) {
      this.setState({ featuredImage: Image, featuredImageUrl: imageUrl });
    }
  }

  async handleFeaturedMediaSelect(file) {
    this.setState({ featuredMediaUrl: file.accessUrl, featuredMediaType: file.type });
  }

  async handleThumbnailSelect(e) {
    var featuredImage = null;
    if (e.type.match('image.*')) {
      featuredImage = e.dataURL;
      // this.setFeaturedImage(e.dataURL, e.accessUrl);
      this.handleCropShow(featuredImage);
    }
    else if (e.type.match('video.*')) {
      let VIDEO = document.createElement('video');
      if (e.isExisting)
        VIDEO.src = e.dataURL;
      else
        VIDEO.src = window.URL.createObjectURL(e);
      VIDEO.type = e.type;
      VIDEO.crossOrigin = "anonymous";
      VIDEO.addEventListener('loadedmetadata', () => {
        VIDEO.currentTime = 0;

        this.capture(VIDEO, (image) => {
          featuredImage = image;
          if (!e.isExisting)
            window.url.revokeObjectURL(VIDEO.src)
          VIDEO = undefined;
          // this.setFeaturedMedia(featuredImage);
          this.handleCropShow(featuredImage);
        })
      })
    }
  }

  handleTranslateClick(e) {
    const title = this.state.blog[0].title;
    const description = this.state.blog[0].description;
    const summery = this.state.blog[0].summery;
    const srcID = this.state.blog[0].language_id;
    const src = this.state.languages.find(({ id }) => id === srcID).language_code;
    const dstID = parseInt(this.state.language_id);
    const dst = this.state.languages.find(({ id }) => id === dstID).language_code;
    this.props.translateText({
      tasks: [
        { src, dst, text: title },
        { src, dst, text: description },
        { src, dst, text: summery },
      ]
    })
    this.setState({ displayTranslateButton: false })
    const intv = setInterval(() => {
      if (this.props.translated) {
        console.log('in translate interval');
        const res = this.props.translated.results;
        this.setState({
          title: res[0],
          editorState: res[1],
          summery: res[2]
        }, clearInterval(intv));
      }
    }, 500);
  }

  handleLanguageChange(language_id) {
    if (this.state.isNew) {
      this.setState({ language_id })
      return;
    }
    const BLOG = this.state.blog.find(element => element.language_id === language_id);
    if (BLOG)
      this.setState({
        title: BLOG.title,
        editorState: BLOG.description,
        language_id,
        displayTranslateButton: false,
      })
    else {
      this.setState({
        title: '',
        editorState: '',
        summery:'',
        displayTranslateButton: true,
        language_id
      })
    }
  }

  capture(VIDEO, callback) {
    // let VIDEO = document.createElement('video');
    // VIDEO.src = video.dataURL;
    // VIDEO.type = video.type;
    // VIDEO.crossOrigin = "anonymous";

    // VIDEO.addEventListener('loadedmetadata', () => {
    let canvas = document.createElement('canvas');
    setTimeout(() => {
      let w = 640 //VIDEO.videoWidth //* this.scaleFactor;
      let h = 480 //VIDEO.videoHeight //* this.scaleFactor;
      // console.log(w);
      canvas.width = w;
      canvas.height = h;
      canvas
        .getContext('2d')
        .drawImage(VIDEO, 0, 0, w, h)
      var img = canvas.toDataURL();
      callback(img);
    }, 500);
    // })
  }


  render() {
    var categoryOptions = [], languageOptions = [];
    if (this.state.categories)
      categoryOptions = this.state.categories.map(element => {
        return <option key={element.id} value={element.id}>{element.category_name}</option>
      })
    categoryOptions.splice(0, 0, <option value="" key="">Select an item</option>);
    if (this.state.languages)
      languageOptions = this.state.languages.map(element => {
        return <option key={element.id} value={element.id}>{element.language_name}</option>
      })
    languageOptions.splice(0, 0, <option value="" key="">Select an item</option>);


    const featuredImage = this.state.featuredImage || this.state.featuredImageUrl || "/broken-image.png";
    // Array.prototype.push(], options)

    return (
      <div className="container-fluid">
        <Modal show={this.state.showModal} onHide={() => this.handleClose()} animation={true}>
          {/* <Modal.Header closeButton>
            <Modal.Title>Modal heading</Modal.Title>
          </Modal.Header> */}
          <Modal.Body>
            {this.state.file && this.state.file.type.match("image.*") && <img alt="" src={this.state.file.dataURL} style={{ width: '100%' }} />}
            {this.state.file && this.state.file.type.match("video.*") &&
              (<>
                <video id="videoPreview" controls src={this.state.file.objectURL} style={{ width: '100%' }} crossOrigin="anonymous" />
                <Button varient="success" onClick={() => this.handleCaptureClick()}>Capture the scene</Button>
              </>)
            }
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => this.handleClose()}>
              Close
          </Button>
          </Modal.Footer>
        </Modal>
        <Modal id="CropModal" show={this.state.showCropModal} onHide={() => this.handleCropClose()} animation={true}>
          <Modal.Body>
            <div ref={this.cropRef} />
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => this.handleCropClose()}>Close</Button>
            <Button variant="success" onClick={() => this.handleCropImage()}>Crop</Button>
            <Button variant="primary" onClick={() => this.Crop.rotate(90)}>Rotate Left</Button>
            <Button variant="primary" onClick={() => this.Crop.rotate(-90)}>Rotate Right</Button>
          </Modal.Footer>
        </Modal>
        <div className="row align-items-center" >
          <div className="col-lg-12 col-md-12 col-sm-12">

            <div className="row align-items-center">
              <div className="col-lg-12 col-md-12 col-sm-12">
                <form>

                  <div className="row align-items-center" style={{ paddingLeft: '2px' }}>
                    <div className="col-lg-12 col-sm-12 col-md-12">
                      <br></br>
                      <h2 style={{ textAlign: "left" }}>{this.state.isEdit ? "Edit blog" : "Create a blog"}</h2>
                    </div>

                  </div>

                  <div className="row align-items-center">
                    <div className="col-md-9 col-md-9 col-lg-9 " style={{ padding: '4px' }}>
                      <div className="shadow-lg p-3 mb-5 bg-white rounded">
                        <img style={{ maxWidth: "100%", maxHeight: "70vh" }} src={featuredImage} alt="Please select a featured." />
                        <Form.Group controlId="formBasicEmail">
                          <Form.Label><b>Title</b></Form.Label>
                          <Form.Control type="text" placeholder="Enter title" value={this.state.title || ""} onChange={(e) => this.setTitle(e)} />
                          <Form.Text>Fit in 8 words</Form.Text>
                        </Form.Group>
                        {/* <div class="form-group">
                          <label for="exampleFormControlInput1"><b>Title</b></label>
                          <input type="text" class="form-control" placeholder="Enter title" value={this.state.title} onChange={(e) => this.setTitle(e)} />
                        </div> */}
                        <Form.Group controlId="exampleForm.ControlTextarea1">
                          <Form.Label><b>Summery</b></Form.Label>
                          <Form.Control as="textarea" rows={2} placeholder="Enter Summery" value={this.state.summery || ""} onChange={e => this.setSummery(e)} />
                        </Form.Group>
                        <div>
                          <label><b>Content</b></label>
                          <Editor
                            handleUploadFile={(...args) => this.handleFileUpload(...args)}
                            existing={this.state.editorState}
                            handleChange={(e) => this.setEditorState(e)}
                          />
                          {/* <E1 handleUploadFile={(...args) => this.handleFileUpload(...args)} /> */}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-3 col-lg-3 col-md-3 " style={{ padding: '4px' }}>
                      <div className="shadow-lg p-3 mb-3 bg-white rounded">
                        <Form.Group controlId="exampleForm.ControlSelect1">
                          <Form.Label><b>Category</b></Form.Label>
                          <Form.Control value={this.state.category_id} as="select" onChange={(e) => this.setCategory(e)}>
                            {categoryOptions}
                          </Form.Control>
                        </Form.Group>
                      </div>
                      <div className="shadow-lg p-3 mb-3 bg-white rounded">
                        <Form.Group controlId="exampleForm.ControlSelect1">
                          <Form.Label><b>Language</b></Form.Label>
                          <Form.Control value={this.state.language_id} as="select" onChange={(e) => this.setLanguage(e)}>
                            {languageOptions}
                          </Form.Control>
                        </Form.Group>
                      </div>
                      {this.state.displayTranslateButton && <Button variant="success" onClick={(...args) => this.handleTranslateClick(...args)} >Auto Translate</Button>}
                      {this.state.is_publish &&
                        <div className="mb-3 shadow-lg p-3 rounded" style={{ backgroundColor: 'rgb(44 255 0 / 76%)' }}>
                          <Form.Check
                            onChange={() => this.handlePublishChange()}
                            type="switch"
                            id="publish-switch"
                            label="Publish"
                            defaultChecked
                          />
                        </div>}

                      <div className="mb-3 shadow-lg p-3 rounded" style={{ backgroundColor: 'rgba(255, 245, 0, 0.81)' }}>
                        <Form.Check
                          onChange={() => this.handleBreakingChange()}
                          type="switch"
                          id="breaking-switch"
                          label="Mark as Breaking News"
                          defaultChecked={this.state.isBreaking}
                        /></div>
                    </div>
                  </div>
                  <h4 style={{ textAlign: "left" }}>Add Images/Videos</h4>
                  <div className="shadow-lg p-3 mb-5 bg-white rounded">
                    <ButtonToolbar id="actions">
                      <Button variant="success" className="fileinput-button m-1" >Add Media</Button>
                      <Button variant="primary" className="fileupload-button m-1" onClick={() => this.uploadAll()}>Upload all</Button>
                    </ButtonToolbar>
                    <div className="dropzone_" ref={this.dropref}>
                      <div className="table table-striped files" id="previews">
                      </div>
                    </div>
                    {/* <Dropzone onDrop={acceptedFiles => this.handleFileDrop(acceptedFiles)}>
                      {({ getRootProps, getInputProps }) => (
                        <section>
                          <div {...getRootProps({ className: 'dropzone' })}>
                            <div className={`form-group ${styles.files} ${styles.color}`}>
                              <input {...getInputProps()} className={styles.file_input} />
                            </div>
                          </div>
                        </section>
                      )}
                    </Dropzone> */}
                    <div id="drop" />
                    {/* {featuredMedia ?
                      <>
                        {this.state.featuredMediaType.match('image.*') && <img style={{ width: "80vmin" }} src={featuredMedia} alt="loading..." />}
                        {this.state.featuredMediaType.match('video.*') && <video controls src={featuredMedia} style={{ width: "80vmin" }} type="video/mp4" />
                          //                       <p>Your browser doesn't support HTML5 video. Here is
                          //  a <a href="myVideo.mp4">link to the video</a> instead.</p> 
                          //                     </video>
                        }
                      </>
                      : <span>No media added</span>} */}
                  </div>

                </form>
              </div>
              <div className="row align-items-center">
                <div className="col-sm-12 col-md-12 col-lg-12 justify-content-end">
                  <div className="">
                    <Button variant="danger" className="m-1" style={{ minWidth: "150px", fontWeight: 600 }} onClick={() => this.props.history.push('/main/blogs/view')}>Close</Button>
                    {this.state.isEdit ?
                      <Button variant="success" className="m-1" style={{ minWidth: "150px", fontWeight: 600 }} onClick={this.updateBlogBody}>Update</Button> :
                      <Button variant="success" className="m-1" style={{ minWidth: "150px", fontWeight: 600 }} onClick={this.saveBlogBody}>Save</Button>
                    }
                    {/* <Button onClick={() => this.renderTable()} variant="danger" style={{ minWidth: "150px", fontWeight: 600 }}>View Blogs</Button> */}
                  </div>
                </div>
              </div>
            </div >
          </div>
        </div>
      </div >
    );
  }
}
const mapStateToProps = ({ reducer: store }) => ({
  blog: store.blog,
  categories: store.categories,
  user: store.user,
  blogSaved: store.blogSaved,
  blogUpdated: store.blogUpdated,
  languages: store.languages,
  translated: store.translated,
});

const mapDispatchToProps = {
  saveBlog: saveBlog,
  fetchBlog: fetchBlog,
  fetchCategories: fetchCategories,
  updateBlog: updateBlog,
  fetchLanguages,
  translateText,
};

function dataURLtoFile(dataurl, filename) {

  var arr = dataurl.split(','),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], filename, { type: mime });
}
export default connect(mapStateToProps, mapDispatchToProps)(BlogForm);



/*    check image upload
      publish blogs */